<style lang="scss" src='@/views/login/Login.scss' scoped ></style>
<style lang="scss" src='./ForgotPassword.scss' scoped ></style>
<template src="./ForgotPassword.html"></template>

<script>
import { ForgotPassword } from '@/api/api';

export default {
  name: 'ForgotPassword',
  data() {
    return {
      email: '',
      loading: false,
    };
  },
  methods: {
    onSubmit(e) {
      e.preventDefault();
      this.loading = true;
      ForgotPassword({ username: this.email })
        .then(() => {
          this.loading = false;
          this.$router.push('/recovery-email-sent');
        })
        .catch(() => {
          this.loading = false;
        });
    },
  },
};
</script>
